export const formatLocale = (locale: string) => {
    // format locale to match the format of the translation file name
    let formattedLocale = locale.replace('_', '-');
    if (formattedLocale.indexOf('-') !== -1) {
        const [language, country] = formattedLocale.split('-');
        formattedLocale = `${language.toLowerCase()}-${country.toUpperCase()}`;
    } else {
        const shortToLongLocales: { [key: string]: string } = {
            de: 'de-DE',
            en: 'en-US',
            es: 'es-419',
            fi: 'fi-FI',
            fr: 'fr-FR',
            it: 'it-IT',
            pt: 'pt-BR',
            ja: 'ja-JP',
            zh: 'zh-CN',
            ko: 'ko-KR',
            nl: 'nl-NL',
        };
        formattedLocale =
            shortToLongLocales[formattedLocale] || formattedLocale;
    }

    return formattedLocale;
};
